import { ArrowForward } from '@mui/icons-material'
import { Button } from '@mui/material'

const NextIconButton = ({ dataTestId = 'ArrowForwardIcon', ...props }) => {
  return (
    <Button {...props}>
      <ArrowForward data-testid={dataTestId} />
    </Button>
  )
}

export default NextIconButton
